import { createAction, props } from '@ngrx/store';
import { ConversationNodeApiError } from './conversation-node.errors';
import { ConversationNodeQuery, ConversationNodeData, ConversationNodeLink } from './types';

const ConversationNode = '[Conversation Node]';
const FocusedConversationNode = '[Focused Conversation Node]';

export const ConversationNodeLoadAction = createAction(
  `${ConversationNode} Load`,
  props<{ filter: ConversationNodeQuery }>(),
);

export const ConversationNodeLoadSucceededAction = createAction(
  `${ConversationNode} Load Succeeded`,
  props<{ seriesData: ConversationNodeData[]; seriesLinks: ConversationNodeLink[] }>(),
);

export const ConversationNodeLoadErroredAction = createAction(
  `${ConversationNode} Load Errored`,
  props<{ apiError: ConversationNodeApiError }>(),
);

export const FocusedConversationNodeLoadAction = createAction(
  `${FocusedConversationNode} Focused Node Load`,
  props<{ focusedName: string }>(),
);

export const FocusedConversationNodeLoadSucceededAction = createAction(
  `${FocusedConversationNode} Focused Node Load Succeeded`,
  props<{ seriesData: ConversationNodeData[]; seriesLinks: ConversationNodeLink[] }>(),
);

export const FocusedConversationNodeLoadErroredAction = createAction(
  `${ConversationNode} Focused Node Load Errored`,
  props<{ apiError: ConversationNodeApiError }>(),
);
